import { Button, Col, Row, Select } from 'antd'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { SEAT_STATUS, TICKET_ENUM } from 'src/services/api/constant'
import BannerEvent1 from 'src/assets/images/banner_show_1.jpg'
import BannerEvent2 from 'src/assets/images/banner_show_2.jpg'
import Layout1 from 'src/assets/images/layout-1.png'
import Layout2 from 'src/assets/images/layout-2.jpg'
import Layout3 from 'src/assets/images/layout-3.jpg'
import { Icon } from 'src/components/common/icons'
import { useEffect, useState } from 'react'
import { has, isEmpty, isInteger } from 'lodash'
import { PaymentPage } from './payment'
import { formatCurrency } from 'src/utils/helper'
import useSettingLayout from 'src/store/hooks/settingLayout'
import { apiGetSeat } from 'src/store/sagas/settingLayout'

export const BuyTicket = () => {
  const token = localStorage.getItem('access_token')
  const navigate = useNavigate()

  if (!token) {
    navigate('/')
  }

  const [searchParams] = useSearchParams()
  const ticketId = searchParams.get('ticketId')

  const [currentLayout, setCurrentLayout] = useState(null)
  const [currentSeat, setCurrentSeat] = useState([])
  const [openPayment, setOpenPayment] = useState(false)
  const [dataPayment, setDataPayment] = useState(null)

  const { actions } = useSettingLayout()
  const templateConfigLayout = [
    {
      title: 'VIP',
      prefix: 'VIP',
    },
    {
      title: 'Hoa Lư 1',
      prefix: 'HL1',
    },
    {
      title: 'Hoa Lư 2',
      prefix: 'HL2',
    },
    {
      title: 'Bái Đính 1',
      prefix: 'BaD1',
    },
    {
      title: 'Bái Đính 2',
      prefix: 'BaD2',
    },
    {
      title: 'Tràng An 1',
      prefix: 'TA1',
    },
    {
      title: 'Tràng An 2',
      prefix: 'TA2',
    },
    {
      title: 'Tam Cốc 1',
      prefix: 'TC1',
    },
    {
      title: 'Tam Cốc 2',
      prefix: 'TC2',
    },
    {
      title: 'Bích Động 1',
      prefix: 'BiD1',
    },
    {
      title: 'Bích Động 2',
      prefix: 'BiD2',
    },
    {
      title: 'Thung Nham 1',
      prefix: 'TN1',
    },
    {
      title: 'Thung Nham 2',
      prefix: 'TN2',
    },
    {
      title: 'Khê Cốc 1',
      prefix: 'KC1',
    },
    {
      title: 'Khê Cốc 2',
      prefix: 'KC2',
    },
    {
      title: 'Cúc Phương',
      prefix: 'CP',
    },
    {
      title: 'Hang Múa',
      prefix: 'HM',
    },
    {
      title: 'Vân Long 1',
      prefix: 'VL1',
    },
    {
      title: 'Vân Long 2',
      prefix: 'VL2',
    },
  ]

  const eventInfo = {
    [TICKET_ENUM.DAY_1]: {
      title: 'Melody show 1/5 - Hoài Niệm',
      startTime: '20H00 - 01/05/2025',
      banner: BannerEvent1,
      address1: 'SÂN KHẤU THUỶ ĐÌNH',
      address2: 'PHỐ CỔ HOA LƯ, ĐƯỜNG TRẦN HƯNG ĐẠO, TP HOA LƯ, NINH BÌNH',
      description:
        'THE EAST - LIVE CONCERT XUÂN trở lại với sự mong mỏi và chờ đón của rất nhiều khán giả trên khắp mọi miền Tổ Quốc. Dàn line up với các anh trai "Sai đẹp chiêu" sẽ mang đến một sân khấu bùng nổ và ấn tượng nhất, khép lại hành trình mùa xuân đầy rực rỡ.',
    },
    [TICKET_ENUM.DAY_2]: {
      title: 'Melody show 2/5 - Thăng Hoa',
      startTime: '20H00 - 02/05/2025',
      banner: BannerEvent2,
      address1: 'SÂN KHẤU THUỶ ĐÌNH',
      address2: 'PHỐ CỔ HOA LƯ, ĐƯỜNG TRẦN HƯNG ĐẠO, TP HOA LƯ, NINH BÌNH',
      description:
        'THE EAST - LIVE CONCERT XUÂN trở lại với sự mong mỏi và chờ đón của rất nhiều khán giả trên khắp mọi miền Tổ Quốc. Dàn line up với các anh trai "Sai đẹp chiêu" sẽ mang đến một sân khấu bùng nổ và ấn tượng nhất, khép lại hành trình mùa xuân đầy rực rỡ.',
    },
  }

  const [configLayout, setConfigLayout] = useState(templateConfigLayout)

  useEffect(() => {
    getListSeat()
  }, [])

  const getListSeat = async () => {
    const query = {
      isGetAll: 1,
      filter: JSON.stringify([
        { column: 'status', text: SEAT_STATUS.AVAILABLE },
        { column: 'eventCode', text: ticketId },
      ]),
    }
    const res = await apiGetSeat(query)
    const dataByArea = {}
    res?.data?.items.forEach((seat) => {
      if (!has(dataByArea, seat.areaCode)) {
        dataByArea[seat.areaCode] = []
      }
      dataByArea[seat.areaCode].push({
        label: seat.code,
        value: seat.code,
        price: seat.price,
      })
    })
    const setting = templateConfigLayout.map((item) => {
      return {
        ...item,
        chair: has(dataByArea, item.prefix)
          ? dataByArea[item.prefix]?.map((seat) => ({
              label: seat.label,
              value: seat.value,
              price: seat.price,
            }))
          : [],
      }
    })
    setConfigLayout(setting)
  }

  if (!ticketId || !Object.values(TICKET_ENUM).includes(ticketId)) {
    return (
      <>
        <Row
          className="flex items-center justify-center mt-8"
          gutter={[24, 24]}
        >
          <Col span={24} className="text-center">
            <h1 className="text-4xl">
              Event không tồn tại. Vui lòng kiểm tra lại!
            </h1>
          </Col>
          <Col span={24} className="text-center">
            <Link to="/">
              <Button type="primary">Back Home</Button>
            </Link>
          </Col>
        </Row>
      </>
    )
    // navigate("/404");
  }

  const [price, setPrice] = useState([])

  useEffect(() => {
    const totalPrice = getPrice(currentSeat)
    setPrice(totalPrice)
  }, [currentSeat]) // Chạy lại khi currentChair thay đổi

  const handleChangeLayout = (value) => {
    setCurrentLayout(value)
    setCurrentSeat([])
  }

  // Hàm xử lý khi chọn ghế
  const handleChangeSeat = (selectedSeat) => {
    setCurrentSeat(selectedSeat) // Cập nhật danh sách ghế được chọn
  }

  const getPrice = () => {
    if (isEmpty(currentSeat)) {
      return ''
    }
    const currentPrice = currentSeat.reduce((accumulator, currentValue) => {
      return configLayout[currentLayout].chair[currentValue].price + accumulator
    }, 0)
    return formatCurrency(currentPrice)
  }

  const handleClickBuyTicket = () => {
    if (!token) {
    }
    if (isEmpty(currentSeat)) {
      alert('Vui lòng chọn ghế')
      return
    }
    const data = {
      eventCode: ticketId,
      areaCode: configLayout[currentLayout].prefix,
      areaName: configLayout[currentLayout].title,
      seat: currentSeat.map((chair) => {
        return {
          name: configLayout[currentLayout].chair[chair].label,
          price: configLayout[currentLayout].chair[chair].price,
        }
      }),
    }
    setDataPayment(data)
    setOpenPayment(true)
  }

  return (
    <>
      <div className="flex items-center justify-center">
        <img
          className="w-full h-auto"
          src={eventInfo[ticketId].banner}
          alt=""
        />
      </div>
      <Row gutter={[24, 24]} className="mt-8 pl-12 pr-12">
        <Col span={24}>
          <h1 className="text-3xl title-event">{eventInfo[ticketId].title}</h1>
          <div className="mt-4">
            <p className="text-xl flex">
              <Icon name="calendar" className="mr-2 w-[24px] inline-flex" />
              <span className="leading-[32px]">
                {eventInfo[ticketId].startTime}
              </span>
            </p>
          </div>
          <div className="flex mt-4 text-[16px] leading-[20px]">
            <Icon name="direction" className="mr-2 w-[24px] h-[20px]" />
            <p className="text-xl">
              {eventInfo[ticketId].address1}
              <br />
              <span className="text-white text-lg inline mt-4">
                {eventInfo[ticketId].address2}
              </span>
            </p>
          </div>
          <h4 className={`uppercase text-2xl text-white mt-4 font-medium`}>
            Mô tả ngắn
          </h4>
          {ticketId === TICKET_ENUM.DAY_1 && (
            <>
              <p className="mt-2 text-xl">
                🔥 ĐẠI NHẠC HỘI “MELODY SHOW” CHÍNH THỨC XUẤT HIỆN TẠI CỐ ĐÔ
                NINH BÌNH!
              </p>
              <p className="mt-2 text-xl">
                “Melody Show” sẽ thổi hồn vào vùng đất Cố Đô Hoa Lư, biến Ninh
                Bình thành điểm đến của những trái tim yêu nhạc và đam mê văn
                hóa.
              </p>
              <p className="mt-2 text-xl">
                🎤 Với những giọng ca độc đáo, những giai điệu quen thuộc từng
                làm mưa làm gió một thời, Medoly Show không chỉ khiến bạn say mê
                với những bản nhạc "cực bắt tai" mà còn đưa bạn trở về những
                ngày tháng tuổi trẻ tràn đầy nhiệt huyết và hoài niệm.
              </p>
            </>
          )}
          {ticketId === TICKET_ENUM.DAY_2 && (
            <>
              <p className="mt-2 text-xl">
                🔥 ĐẠI NHẠC HỘI “MELODY SHOW” SẴN SÀNG KHUẤY ĐỘNG CỐ ĐÔ NINH
                BÌNH!
              </p>
              <p className="mt-2 text-xl">
                🎇 Lần đầu tiên - một lễ hội âm nhạc không thể bỏ qua vào 2/5
                này, “Melody Show” sẽ thổi hồn vào vùng đất Cố Đô Hoa Lư, biến
                Ninh Bình thành điểm đến của những trái tim yêu nhạc và đam mê
                văn hóa. Đây không chỉ là một sự kiện âm nhạc, mà là một cơn lốc
                cảm xúc, hội tụ dàn sao cực chất. Hứa hẹn sẽ mang đến một đêm âm
                nhạc thật khó quên.
              </p>
            </>
          )}
        </Col>
      </Row>
      <Row gutter={[24, 24]} className="mt-8 pl-12 pr-12 bg-black">
        <Col span={24} md={10} className="pt-4 pb-4">
          <h4 className="text-center text-xl">Chọn vé</h4>
          <Select
            onChange={handleChangeLayout}
            allowClear
            style={{ width: '100%', color: '#000', marginTop: '20px' }}
            placeholder="Chọn khu"
            options={configLayout.map((layout, index) => ({
              label: layout.title,
              value: index,
            }))}
          />

          <Select
            onChange={handleChangeSeat}
            mode="multiple"
            allowClear
            style={{ width: '100%', color: '#000', marginTop: '10px' }}
            placeholder="Chọn ghế"
            value={currentSeat}
            options={
              isInteger(currentLayout)
                ? configLayout[currentLayout]?.chair?.map((seat, index) => ({
                    label: seat.label,
                    value: index,
                  }))
                : []
            }
          />
          <Button
            onClick={handleClickBuyTicket}
            style={{
              cursor: isEmpty(currentSeat) ? 'not-allowed' : 'pointer',
            }}
            className="mt-4 w-[280px] m-auto block bg-[#38b6ff] text-white border-none btn-pay"
          >
            Thanh toán
            {isEmpty(currentSeat) ? '' : ` - ${price}`}
          </Button>
        </Col>
        <Col
          span={24}
          md={14}
          className="pt-4 pb-4 flex items-center justify-center flex-wrap bg-[#38383d]"
        >
          <h4 className="text-center text-xl w-full mb-4">Layout</h4>
          <img className="w-full max-w-[500px] m-1" src={Layout1} />
          <img className="w-full max-w-[500px] m-1" src={Layout2} />
          <img className="w-full max-w-[500px] m-1" src={Layout3} />
        </Col>
      </Row>
      <PaymentPage
        open={openPayment}
        data={dataPayment}
        setOpenPayment={setOpenPayment}
      />
    </>
  )
}
